import React, { useEffect, useState } from "react";
import { useLazyBookingDetailsQuery } from "../../redux/api/api";
import TopHeader from "../Dashoboard/TopHeader";
import { useDispatch } from "react-redux";
import { saveLoader } from "../../redux/slice/loaderNoti";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment/moment";

const BlockView = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [details, setDetails] = useState({});

  // RTK QUERY
  const [bookingDetailsApi] = useLazyBookingDetailsQuery();

  const getBookingDetails = () => {
    dispatch(saveLoader(true));
    bookingDetailsApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setDetails(res);
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getBookingDetails();
    }
  }, []);

  return (
    <div className="dashRightView home_section">
      <TopHeader type={"block-view"} />
      <div className=" block block-rounded ">
        <div className="block-content">
          <div className="user-detail-table">
            <table className="tabledetails table-borderless user-det w-100 mb-5">
              <thead>
                <th colspan="3" className="h8 mb-0 font-weight-light p-3">
                  Property & Owner Details
                </th>
              </thead>
              <tbody>
                <tr>
                  <td style={{ width: "40%" }}>Property ID</td>
                  <td>:</td>
                  <td>
                    <button
                      className="link-btn"
                      onClick={() => {
                        navigate("/property-view", {
                          state: {
                            type: "edit",
                            data: details?.booking?.property,
                          },
                        });
                      }}
                    >
                      {details?.booking?.property?.property_id}
                    </button>
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Owner ID</td>
                  <td>:</td>
                  <td>
                    <button
                      className="link-btn"
                      onClick={() => {
                        navigate("/property-owner-view", {
                          state: {
                            type: "edit",
                            data: details?.booking?.owner,
                          },
                        });
                      }}
                    >
                      {details?.booking?.owner?.owner_id}
                    </button>
                  </td>
                </tr>
                <tr class="bg-purple p-2 rounded my-2">
                  <td colspan="3" class="h8_2 mb-0 font-weight-light p-3">
                    Blocked Details
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Blocked By</td>
                  <td>:</td>
                  <td>
                    {details?.booking?.booked_by == 2
                      ? "Owner"
                      : details?.booking?.booked_by == 3
                      ? "Receptionist"
                      : "Admin"}
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Blocked Person</td>
                  <td>:</td>
                  <td>
                    {details?.booking?.booked_by == 2 ? (
                      <button
                        className="link-btn"
                        onClick={() => {
                          navigate("/property-owner-view", {
                            state: {
                              type: "edit",
                              data: details?.booking?.owner,
                            },
                          });
                        }}
                      >
                        {details?.booking?.owner?.name}
                      </button>
                    ) : details?.booking?.booked_by == 3 ? (
                      <button
                        className="link-btn"
                        onClick={() => {
                          navigate("/property-owner-view", {
                            state: {
                              type: "edit",
                              data: details?.booking?.receptionist,
                            },
                          });
                        }}
                      >
                        {details?.booking?.receptionist?.name}
                      </button>
                    ) : details?.booking?.booked_by == 4 ? (
                      <button
                        className="link-btn"
                        onClick={() => {
                          navigate("/admin", {
                            state: {
                              type: "view",
                              data: details?.booking?.admin,
                            },
                          });
                        }}
                      >
                        {details?.booking?.admin?.name}
                      </button>
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>From Date</td>
                  <td>:</td>
                  <td>
                    {details?.booking?.from_date
                      ? moment(details?.booking?.from_date).format(
                          "DD-MM-YYYY hh:mm a"
                        )
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>To Date</td>
                  <td>:</td>
                  <td>
                    {" "}
                    {details?.booking?.to_date
                      ? moment(details?.booking?.to_date).format(
                          "DD-MM-YYYY hh:mm a"
                        )
                      : ""}
                  </td>
                </tr>
                <tr>
                  <td style={{ width: "40%" }}>Service Type</td>
                  <td>:</td>
                  <td>{details?.booking?.service_type}</td>
                </tr>
                {details?.booking?.service_type == "room_booking" ||
                details?.booking?.service_type == "room_sharing" ? (
                  <tr>
                    <td style={{ width: "40%" }}>No.of.Rooms</td>
                    <td>:</td>
                    <td>{details?.booking?.no_of_rooms}</td>
                  </tr>
                ) : null}
                {details?.booking?.service_type == "room_booking" ||
                details?.booking?.service_type == "room_sharing" ||
                details?.booking?.service_type == "get_together" ? (
                  <tr>
                    <td style={{ width: "40%" }}>Room Name</td>
                    <td>:</td>
                    <td>{details?.booking_room_details?.room?.room_name}</td>
                  </tr>
                ) : null}
                {details?.booking?.service_type == "room_booking" ||
                details?.booking?.service_type == "room_sharing" ||
                details?.booking?.service_type == "get_together" ? (
                  <tr>
                    <td style={{ width: "40%" }}>Room Time Slot</td>
                    <td>:</td>
                    <td>
                      {details?.booking_room_details?.roomslot?.timeslot?.name}
                    </td>
                  </tr>
                ) : null}
                {details?.booking?.service_type == "room_booking" ||
                details?.booking?.service_type == "room_sharing" ||
                details?.booking?.service_type == "get_together" ? (
                  <tr>
                    <td style={{ width: "40%" }}>Start Time / Hrs</td>
                    <td>:</td>
                    <td>
                      {
                        details?.booking_room_details?.roomslot?.timeslot
                          ?.start_time
                      }{" "}
                      /{" "}
                      {details?.booking_room_details?.roomslot?.timeslot?.type}
                    </td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlockView;
